import React, { useEffect, useState } from "react";
import Main from "./layout/Main";

export default function PageNotFound(props) {
  return <Main>PAGE NOT FOUND!</Main>;
}
